import { Button } from '@/shared/components/ui/button'
import { cn } from '@shared/lib/utils'

interface StepActionsProps {
  onBack?: () => void
  onNext: () => void
  nextDisabled?: boolean
  className?: string
  backLabel?: string
  nextLabel?: string
}

export function StepActions({
  onBack,
  onNext,
  nextDisabled,
  className,
  backLabel = 'Back',
  nextLabel = 'Next',
}: StepActionsProps) {
  return (
    <div className={cn('mt-5 flex items-center justify-center gap-4 max-sm:flex-col', className)}>
      {onBack ? (
        <Button
          type="button"
          variant="outline-client"
          className="min-h-[50px] w-full rounded-2xl border border-client-primary px-6 py-4 text-client-primary"
          onClick={onBack}
        >
          {backLabel}
        </Button>
      ) : null}
      <Button
        type="button"
        variant="default-client"
        className="min-h-[50px] w-full rounded-2xl px-6 py-4"
        onClick={onNext}
        disabled={nextDisabled}
      >
        {nextLabel}
      </Button>
    </div>
  )
}
